import { useStateMachine } from "components/context/stateMachine/StateMachineContext"
import { Steps } from "components/cmd-enrollment/workflow/steps"
import React from "react"
import { Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { Container, FlexContainer, H2 } from "@carrotfertility/carotene"
import { BenefitEnrollmentModalContinueButton } from "../../../shared"
import { IlloBlocks } from "../../../../views/atoms/Illustrations"
import { TextLink } from "../../../../views/atoms/links/TextLink"
import { ZendeskTextLink } from "../../../../views/atoms/links/ZendeskTextLink"
import { FormattedMessage } from "react-intl"

export function PartnerConnectSuccess(): JSX.Element {
  const { setNextStep } = useStateMachine(Steps.PARTNER_PROCESS_CONNECT_INSURANCE_SUCCESS, null)

  function onClickContinue(): void {
    setNextStep(Steps.PARTNER_PROCESS_CONNECT_INSURANCE_SUCCESS, "")
  }

  return (
    <div>
      <Spacer height={3} />
      <FlexContainer justifyContent="center" padding="none" stack="medium">
        <IlloBlocks />
      </FlexContainer>
      <H2 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Connection was successful." />
      </H2>
      <Container padding="none" stack="huge">
        <Body color="black-80">
          <FormattedMessage
            defaultMessage="We'll take it from here and will let you know if we have any more questions about their insurance. 
        If we determine that they have a deductible, you'll see the status on the <link>Transactions tab</link>. You can read more about deductibles in our <zendeskLink>Support Center</zendeskLink>"
            values={{
              link: (linkContent) => <TextLink href="/transactions">{linkContent}</TextLink>,
              zendeskLink: (linkContent) => <ZendeskTextLink>{linkContent}</ZendeskTextLink>
            }}
          />
        </Body>
      </Container>
      <BenefitEnrollmentModalContinueButton onClick={onClickContinue} />
    </div>
  )
}

export function MemberConnectSuccess(): JSX.Element {
  const { setNextStep } = useStateMachine(Steps.MEMBER_PROCESS_CONNECT_INSURANCE_SUCCESS, null)

  function onClickContinue(): void {
    setNextStep(Steps.MEMBER_PROCESS_CONNECT_INSURANCE_SUCCESS, "")
  }

  return (
    <div>
      <Spacer height={3} />
      <FlexContainer justifyContent="center" padding="none" stack="medium">
        <IlloBlocks />
      </FlexContainer>
      <H2 variant="primary" stack="tiny">
        <FormattedMessage defaultMessage="Connection was successful." />
      </H2>
      <Container padding="none" stack="huge">
        <Body color="black-80">
          <FormattedMessage defaultMessage="We'll take it from here and will let you know if we have any more questions about your insurance." />
        </Body>
      </Container>
      <BenefitEnrollmentModalContinueButton onClick={onClickContinue} />
    </div>
  )
}
